import EzModalController from 'layouts/modal/modal-controller';
import Cookies from 'js-cookie';

export default class SignupSurveyModalController extends EzModalController {
  static targets = [
    'surveyForm',
  ];

  connect() {
    super.connect();

    this.flagLoaded();
  }

  disconnect() {
    super.disconnect();
  }

  close = (event) => {
    super.close(event, () => {}, this.dismissAfterUserClose);
  }

  dismissAfterUserClose = (event) => {
    // we only want to fire the dismiss action if the user manually closes the modal
    if (event.currentTarget.getAttribute('data-action').includes('signup-survey-modal#close')) {
      if (Cookies.get('no_verified_survey_dismissal_reload')) {
        Cookies.remove('no_verified_survey_dismissal_reload');
        return;
      }

      const userId = this.surveyFormTarget.getAttribute('data-user-id');
      Turbolinks.visit(`/signup/survey/dismiss/${userId}`);
    }
  }
}
